/**
 * Default page insets in mm.
 */
export const DEFAULT_PAGE_INSETS = {
	left: 320,
	right: 175,
	top: 145,
	bottom: 365,
} as const;

export type PageInsets = typeof DEFAULT_PAGE_INSETS;

export const DEFAULT_FOLD_MARKS = {
	top: 33,
	middle: 50,
	bottom: 66,
} as const;

export const DEFAULT_LOGO_CONTAINER_HEIGHT = 455;
export const MAX_LOGO_HEIGHT = 310;
export const MAX_LOGO_WIDTH = 830;
export const COMPANY_INFORMATION_MIN_HEIGHT = 325;
export const COMPANY_INFORMATION_BOTTOM_PADDING = 20;
export const COMPANY_INFORMATION_WIDTH = MAX_LOGO_WIDTH;
export const CENTER_DOT = "·";
